<div>
  <!-- <ck-editor #ckEditor="ckEditor" [(ngModel)]="value" (change)="onChange($event)" [config]="config" (ready)="ckeditorReady($event)"></ck-editor> -->
  <!-- <ckeditor #ckEditor id="ckEditor1" [editor]="Editor" [data]="value" [config]="config" (ready)="onReady($event)"
    (change)="onChange($event)">
  </ckeditor> -->
  <angular-editor [(ngModel)]="value" [config]="editorConfig" (html)="onChange($event)"></angular-editor> 
</div>